export const GET_ACCOUNTS = "get-accounts";
export const GET_ACCOUNTS_CATEGORIZE = "get-accounts-categorize";
export const GET_BANK_CONNECTIONS = "get-bank-connections";
export const GET_BANK_CONNECTION = "get-bank-connection";
export const GET_DISCOUNTS_KEY = "get-discounts";
export const GET_REMOTE_ACCOUNTS = "get-remote-accounts";
export const MY_DEPOTS = "my-depots";
export const MY_INVOICES = "my-invoices";
export const GET_SELECTED_GROUP = "get-selected-group";
export const GET_SECURITY_COMISSIONS = "GET_SECURITY_COMISSIONS";
export const GET_REGIONS_KEY = "get-regions";
export const GET_INDUSTRIES_KEY = "get-industries";
export const GET_INVESTMENT_KEY = "get-investment";
export const GET_INVESTMENTS = "get-investments";
export const GET_INVESTMENTS_GAINERS_AND_LOSERS =
  "get-investments-gainers-and-losers";
export const GET_TAGS_KEY = "get-tags";
export const GET_PERFORMANCE_BY_DEPOTS = "get-performance-by-depots";
export const GET_RISK_YIELD_ESTIMATES_KEY = "get-risk-yield-estimates";
export const LOAD_FUND_BY_ISIN = "load_fund_by_isin";
export const LOAD_FUNDAMENTAL_BY_ISIN = "load-fundamental-by-isin";
export const LOAD_MARKET_CAP_BY_ISIN = "load-market-cap-by-isin";
export const GET_CURRENCIES_KEY = "get-currencies";
export const GET_HISTORIC_QUOTES = "get-historic-quotes";
export const GET_HISTORIC_QUOTES_LOOKUP = "get-historic-quotes-lookup";
export const GET_HISTORIC_QUOTES_INTRADAY = "get-historic-quotes-intraday";
export const GET_EXCHANGE_RATE = "get-exchange-rate";
export const GET_SUBSCRIPTIONS = "get-subscriptions";
export const GET_ACCOUNT_HOLDERS = "get-account-holders";
export const GET_REALIZED_GAINS = "get-realized-gains";
export const GET_WATCHLISTS = "get-watchlists";
export const GET_WATCHLISTS_ENTRIES = "get-watchlists-entries";
export const GET_WATCHLISTS_ENTRY = "get-watchlists-entry";
export const GET_SINGLE_WATCHLIST = "get-single-watchlist";
export const GET_SYMBOL = "get-symbol";
export const GET_APPLICATION_PROPERTIES = "get-application-properties";
export const GET_SPLIT_KEY = "get-split";
export const GET_SPLITS_KEY = "get-splits";
export const GET_DIVIDENDS_MASTER_KEY = "get-dividends-master";
export const GET_DIVIDEND_MASTER_KEY = "get-dividend-master";
export const GET_FUNDS_KEY = "get-funds";
export const GET_USER_PROFILE_KEY = "get-user-profile";
export const GET_USER_PROFILE_SUBSCRIPTION_KEY =
  "get-user-profile-subscription";
export const GET_FUND_COMMISITIONS_KEY = "get-fund-commissions";

export const ACCOUNT = "account";

export const ACCOUNT_PERFORMANCE_BY_ASSET_TYPES =
  "account-performance-by-asset-types";
export const ACCOUNT_PERFORMANCE_BY_ACCOUNT_IDS =
  "account-performance-by-account-ids";

export const ACCOUNT_BALANCES = "account-balances";
export const TRANSACTIONS = "transactions";
export const HISTORIC_QUOTES = "historic-quotes";

export const INVESTMENT_PERFORMANCE = "investment-performance";
export const DIVIDENDS = "dividends";
export const GET_NEWS_FEED_RENTABLO_BLOG = "get-news-feed-rentablo-blog";
export const CLASSIFICATION_BY_CURRENCY = "classification-by-currency";

export const GET_BY_QUOTE_PROVIDER_AND_TICKER =
  "get-by-quote-provider-and-ticker";

export const GET_USER_PROFILE_IMAGE = "get-user-profile-image";
export const GET_DIVIDENDS_CALENDAR = "get-dividends-calendar";
export const GET_TAX_ESTIMATE_KEY = "get-tax-estimate";
export const GET_DIVIDENDS_PORTFOLIO_YIELD = "get-dividends-portfolio-yield";
export const GET_DIVIDENDS_HISTORY = "get-dividends-history";
export const GET_DIVIDENDS_PREDICTION = "get-dividends-prediction";
export const GET_AND_VALIDATE_FINANZFLUSS_BOOKINGS_KEY =
  "get-and-validate-finanzfluss-bookings";
